import { useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const ImageGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(images[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToPrevious = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    const newIndex = currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  return (
    <>
      {/* Gallery Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4" data-testid="image-gallery">
        {images.map((image, index) => (
          <div
            key={index}
            className="gallery-item aspect-square rounded-lg overflow-hidden cursor-pointer border border-[#D4AF37]/10 hover:border-[#D4AF37]/40 transition-all"
            onClick={() => openLightbox(index)}
            data-testid={`gallery-image-${index}`}
          >
            <img
              src={image}
              alt={`Gallery image ${index + 1}`}
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
              loading="lazy"
            />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-[#0F0505]/98 flex items-center justify-center p-4"
          onClick={closeLightbox}
          data-testid="lightbox"
        >
          {/* Close Button */}
          <button
            className="absolute top-6 right-6 text-[#F5F5F0] hover:text-[#D4AF37] transition-colors z-10"
            onClick={closeLightbox}
            data-testid="lightbox-close"
            aria-label="Close lightbox"
          >
            <X className="w-8 h-8" />
          </button>

          {/* Previous Button */}
          <button
            className="absolute left-4 md:left-8 text-[#F5F5F0] hover:text-[#D4AF37] transition-colors p-2 glass rounded-full"
            onClick={goToPrevious}
            data-testid="lightbox-prev"
            aria-label="Previous image"
          >
            <ChevronLeft className="w-8 h-8" />
          </button>

          {/* Image */}
          <img
            src={selectedImage}
            alt="Selected"
            className="max-h-[85vh] max-w-[90vw] object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
            data-testid="lightbox-image"
          />

          {/* Next Button */}
          <button
            className="absolute right-4 md:right-8 text-[#F5F5F0] hover:text-[#D4AF37] transition-colors p-2 glass rounded-full"
            onClick={goToNext}
            data-testid="lightbox-next"
            aria-label="Next image"
          >
            <ChevronRight className="w-8 h-8" />
          </button>

          {/* Image Counter */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[#A18E90] text-sm">
            {currentIndex + 1} / {images.length}
          </div>
        </div>
      )}
    </>
  );
};
